// src/components/AutoAssignTypes.ts
export interface FilterGroup {
	filters: any[];
}

export interface AssignmentField {
	key: string;
	label: string;
	options: { value: string; label: string }[];
	multiple: boolean;
}

export interface AssignmentInput {
	type: 'users' | 'roles' | 'teams';
	values: { label: string; value: string }[];
}


export interface Rule {
	id: string;
	name: string;
	priority: number;
	strategy: string;
	filters: FilterGroup[];
	assignments: Record<string, AssignmentInput>;
}

export interface AutoAssignConfig {
	enabled: boolean;
	mode: 'FIRST_MATCH' | 'AGGREGATE';
	rules: Rule[];
}

export const STRATEGIES: { value: string; label: string }[] = [
	{ value: 'ROUND_ROBIN', label: 'Round-Robin' },
	{ value: 'LOAD_BASED', label: 'Least-Busy' },
	{ value: 'SKILL_BASED', label: 'Skill-Based' },
	{ value: 'HYBRID', label: 'Hybrid' },
];

export const STRATEGY_HELPERS: Record<string, string> = {
	ROUND_ROBIN: 'Distributes assignments equally among selected users.',
	LOAD_BASED: 'Assigns to the least busy user based on current load.',
	SKILL_BASED: 'Matches based on skill and filters. Assigns accordingly.',
	HYBRID: 'Combines multiple strategies for balanced assignment.',
};

